import { BcitiLang } from '@bciti/types';

export const DEFAULT_LANG = BcitiLang.FR;
